<template>
	<div class="media" v-if="En && list && list.length">
		<div class="media-content">
			<img class="media-title" v-if="isPc" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/title-home-partners-en.png?t=1" alt="">
			<img class="media-title" v-else src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/wap/title-home-partners-en.png?t=1" alt="">
		</div>
		<div class="media-list">
			<div class="list">
				<div class="item" @click="linkFn(item)" v-for="(item, index) in list" :key="index" :style="{ backgroundImage: `url(${ item.coverUrl })` }"></div>
			</div>
		</div>
	</div>
</template>

<script>
import protal from "@/api/protal";
import router from "../router";
export default {
    name: "display",
    data() {
        return {
            list: []
        };
    },
    created() {
        this.getData();
    },
    methods: {
		getData() {
			const params = {
				pageNum: 1,
				pageSize: 999
			}
			protal.webMediaList(params).then(res => {
				this.list = res.data
			})
		},
		linkFn(item) {
			if (item.linkUrl) {
				location.href = item.linkUrl
			}
		}
    },
}
</script>

<style lang="less" scoped="scoped">
@media screen and (min-width: 769px) {
	.media {
		background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/chilun2.png);
		background-size: 232px auto;
		background-repeat: no-repeat;
		background-position: 20px -80px;

		.media-content {
			width: 1640px;
			height: 280px;
			margin: 0 auto;
			border-bottom: 1px solid rgba(255, 255, 255, 0.2);
			position: relative;
		}

		.media-title {
			position: absolute;
			right: 0;
			bottom: 0;
			width: auto;
			height: 144px;
		}

		.media-list {
			border-bottom: 2px solid rgba(255, 255, 255, 0.4);
		}

		.list {
			width: 1640px;
			margin: 0 auto;
			padding: 60px 0 120px;
			display: flex;

			.item {
				width: 256px;
				height: 128px;
				border-radius: 24px;
				background-repeat: no-repeat;
				background-size: contain;
				background-position: center center;
				background-color: rgba(255, 255, 255, 0.4);
				margin: 0 20px 20px 0;
				cursor: pointer;
			}
		}
	}
}

@media screen and (max-width: 768px) {
	.media {
		background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/chilun2.png);
		background-size: 1.42rem auto;
		background-repeat: no-repeat;
		background-position: -0.2rem -0.4rem;

		.media-content {
			width: 100%;
			margin: 0 auto;
			position: relative;
			height: 3.2rem;

			&::after {
				content: "";
				position: absolute;
				left: .36rem;
				right: .36rem;
				bottom: 0;
				border-bottom: 1px solid rgba(255, 255, 255, 0.2);
			}
		}

		.media-title {
			width: 100%;
			height: auto;
			position: absolute;
			left: 0;
			top: 1.2rem;
		}

		.media-list {
			position: relative;
			z-index: 1;
			border-bottom: 2px solid rgba(255, 255, 255, 0.4);
		}

		.list {
			width: 7.14rem;
			margin-left: 0.36rem;
			padding: 0.48rem 0 1.2rem;
			display: flex;
			flex-wrap: wrap;

			.item {
				width: 2.12rem;
				height: 1.06rem;
				border-radius: 0.28rem;
				background-repeat: no-repeat;
				background-size: contain;
				background-position: center center;
				background-color: rgba(255, 255, 255, 0.4);
				margin: 0 0.2rem 0.2rem 0;
				cursor: pointer;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/media.vue